import React from 'react';

const InfoSection = ({ title = "💡 How to Use", className = "" }) => {
  return (
    <section className={`info-section ${className}`} aria-labelledby="info-section-title">
      <h2 id="info-section-title">{title}</h2>
      <ul className="info-grid" role="list">
        <li className="info-item">
          <div className="step-number">1</div>
          <h4>Enter Your Query</h4>
          <p>
            Describe what you’re looking for in natural language. For example: “revenue growth in Q3,” “profit margin analysis,” or “cash flow trends.”
          </p>
        </li>

        <li className="info-item">
          <div className="step-number">2</div>
          <h4>Filter by Company</h4>
          <p>
            Optionally select a specific company to narrow down your search results to that company’s reports.
          </p>
        </li>

        <li className="info-item">
          <div className="step-number">3</div>
          <h4>Choose Report Type</h4>
          <p>
            Filter by report type such as quarterly reports, annual reports, or earnings calls.
          </p>
        </li>

        <li className="info-item">
          <div className="step-number">4</div>
          <h4>Review Results</h4>
          <p>
            Browse through relevant excerpts from company reports with metadata and relevance scores.
          </p>
        </li>
      </ul>
    </section>
  );
};

export default InfoSection;
